import React from 'react';
import ForbiddenPage from '../pages/ForbiddenPage';
import { PermissionAction, hasModuleAction } from '../utils/permissions';

interface ProtectedModuleRouteProps {
  moduleName: string;
  requiredAction?: PermissionAction;
  children: React.ReactNode;
  onGoHome?: () => void;
}

const ProtectedModuleRoute: React.FC<ProtectedModuleRouteProps> = ({
  moduleName,
  requiredAction = 'read',
  children,
  onGoHome,
}) => {
  if (!hasModuleAction(moduleName, requiredAction)) {
    return <ForbiddenPage onGoHome={onGoHome} />;
  }

  return <>{children}</>;
};

export default ProtectedModuleRoute;